import { IconButton } from '@dixa/lib-shared-habla';
import classnames from 'classnames';

import styles from './mimSidekickLauncher.module.scss';

type MimSidekickLauncherProps = {
  onClick: () => void;
};

export const MimSidekickLauncher = ({
  onClick,
}: MimSidekickLauncherProps): JSX.Element => {
  return (
    <IconButton
      icon="mim-sidekick"
      variant="primary"
      onClick={onClick}
      iconSize={24}
      className={classnames(styles.launcher, 'print-hidden')}
      size="large"
    />
  );
};
